import React from 'react'

import PropTypes from 'prop-types'
import { twMerge } from 'tailwind-merge'

import { Row } from '../../v2/Grid'
import { Text } from '../Text'

const PageTitle = ({ title, children, className, ...props }) => {
	const isTitleChildren = typeof title !== 'string'

	return (
		<Row className='justify-center bg-white'>
			<Row
				as='section'
				className={twMerge(
					'w-full bg-white px-[17px] sm:w-[1140px] sm:px-[10px]',
					className
				)}
				{...props}
			>
				{isTitleChildren ? (
					children
				) : (
					<Text
						variant='big'
						className='text-left font-normal text-gray-900 md:text-2xl'
					>
						{title}
					</Text>
				)}
			</Row>
		</Row>
	)
}

PageTitle.propTypes = {
	title: PropTypes.string
}

export { PageTitle }
